import { render, staticRenderFns } from "./PublishedTeam.vue?vue&type=template&id=147ff842"
import script from "./PublishedTeam.vue?vue&type=script&lang=js"
export * from "./PublishedTeam.vue?vue&type=script&lang=js"
import style0 from "./PublishedTeam.vue?vue&type=style&index=0&id=147ff842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports